import React from 'react';
import { Link } from 'react-router';

import Navigation from 'components/molecules/Navigation';

import JustsleepLogo from 'images/icons/logo-justsleep-short.svg';

import styles from './index.css';

const HeaderHome = ({ page }) => (
	<header className={styles.headerHome}>
		<div className={styles.left}>
			<Navigation type="home" />
		</div>
		{page !== 'main' && (
			<Link to="/" className={styles.logo}>
				<JustsleepLogo viewBox="0 0 289 60" width="100%" height="50px" />
			</Link>
		)}
	</header>
);

export default HeaderHome;



// WEBPACK FOOTER //
// ./src/components/organisms/HeaderHome/component.js